exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".layout[data-v-07500650]{display:flex;flex-direction:column;min-height:100vh}.layout__inner[data-v-07500650]{flex-grow:1}.layout[data-v-07500650] .sidebar__toggle{background:#ffde07}@media screen and (max-width:767px){.layout[data-v-07500650] .sidebar__title{background:#ffde07}}", ""]);

